export default "__VITE_ASSET__DI4HRRz4__"